import React from 'react';
import DynaModal from "../Modal/DynaModal";

const ModalCheckDelete = ({onClose, setRequestDeleteModal, setShowDeleteModal}) => {

    return (
        <DynaModal onClose={onClose} className={'small-modal'}>

            <div className="content-modal ">

                <p>از حذف پیگیری مطمئن هستید ؟</p>

                <div className="row-button">
                    <button className="cancel-saden-modal" onClick={() => setShowDeleteModal(false)}>خیر</button>
                    <button className="accept-saden-modal"
                            onClick={() => setRequestDeleteModal(Math.random())}>بله</button>
                </div>

            </div>
        </DynaModal>
    );
};
export default ModalCheckDelete;